import { Table } from "antd"
import { Button, Modal } from "react-bootstrap"
import { columns, dataSource, setDataSource } from "./configs"
import axios from "axios"
import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import * as links from "../../../utils/links";

export default function ExtraMoveModal(props) {
  const {
    showModal,
    setShowExtraMove,
    maquinaInfos,
    clienteInfo
  } = props

  const configJogadaBonus = maquinaInfos.config_jogada_bonus

  setDataSource(configJogadaBonus)

  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate();

  const token = authInfo?.dataUser?.token;

  const updateExtraMove = async () => {
      setLoading(true)
      let body = {
        id: maquinaInfos.id,
        configJogadaBonus: JSON.stringify(dataSource)
      }

      axios.put(`${process.env.REACT_APP_SERVIDOR}/maquina/extramove`, body, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }).then((res) => {
        setNotiMessage({
          type: "success",
          message:
            `${`Jogada bônus atualizada com sucesso`}`,
        });

        if (clienteInfo) {
          navigate(`${links.CLIENTES_MAQUINAS}/${clienteInfo.id}`, {
            state: clienteInfo,
          });
        } else {
          navigate(links.DASHBOARD_FORNECEDOR);
        }
      }).catch((err) => {
        setNotiMessage({
          type: "error",
          message:
            'Não foi possível atualizar a jogada extra, comunique o administrador',
        });
        console.log('Não foi possível atualizar a jogada extra, comunique o administrador', err)
      }).finally(() => {
        setShowExtraMove(false)
        setLoading(false)
      })
  }

  return (
      <Modal
        show={showModal}
        centered
        style={{ textAlign: "center" }}
      >
        <Modal.Header closeButton className="modal-footer">
          <Modal.Title>
            Configuração de jogada extra
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table
              className="custom-table"
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              loading={false}
              scroll={{ x: 'max-content' }}
            />
        </Modal.Body>
        <Modal.Footer className="modal-footer">
            <>
              <Button variant="secondary" onClick={() => setShowExtraMove(false)}>
                Cancelar
              </Button>
              <Button
                variant="primary"
                onClick={async () => await updateExtraMove()}
              >
                {
                  loading ? 'Salvando...' : 'Salvar'
                }
              </Button>
            </>
        </Modal.Footer>
      </Modal>
    )
}